import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { FileUpload } from '@classes/file/file-upload';
import { FileService } from '@services/file.service';
import { UploadStatus } from '@enums/upload-status.enum';
import { UploadBaseComponent } from '../upload-base/upload-base.component';

@Component({
    selector: 'app-upload-single',
    templateUrl: './upload-single.component.html',
    styleUrls: ['./upload-single.component.scss']
})
export class UploadSingleComponent extends UploadBaseComponent implements OnChanges {
    @Input() allowedFileName: string;
    @Input() isLoading: boolean;
    @Output() startUploading = new EventEmitter<File>();

    // file: FileUpload;
    file: File;
    isNameError: boolean;

    constructor(fileSrv: FileService) {
        super(fileSrv);
    }

    ngOnChanges() {
        if (!this.isLoading) {
            this.file = null;
        }
    }

    onSelectFile(event): void {
        if (event.target.files && event.target.files.length) {
            // const selFile: File = event.target.files[0];
            // this.file = new FileUpload(selFile);
            this.file = event.target.files[0];

            // if (this.verifyFileName(this.file.name)) {
            //     this.isNameError = false;
            //     this.startUpload();
            // } else {
            //     this.file = null;
            //     this.isNameError = true;
            // }
        }
    }

    startUpload(): void {
        this.startUploading.emit(this.file);
        this.file = null;
        // this.fileSrv.uploadWithProgress(this.file, 'BudgetFilePath', 'THOT_BUD', 'Budget.xlsx')
        // .subscribe(res => {
        //     this.file = res;
        //     if (res.fileInfo == null) {
        //         this.file.status = UploadStatus.uploading;
        //     } else {
        //         this.file.status = UploadStatus.done;
        //         this.afterFilesUpload.emit(res.fileInfo);
        //     }
        //     // console.log(this.file);
        // }, () => {
        //     this.file.status = UploadStatus.fail;
        // });
    }

    cancelFile(): void {
        this.file = null;
    }

    // private verifyFileName(fileName: string): boolean {
    //     if (!this.allowedFileName || this.allowedFileName === fileName) {
    //         return true;
    //     }

    //     return false;
    // }
}
